import { render, staticRenderFns } from "./JsonNode.vue?vue&type=template&id=996da9f0&scoped=true"
import script from "./JsonNode.vue?vue&type=script&lang=js"
export * from "./JsonNode.vue?vue&type=script&lang=js"
import style0 from "./JsonNode.vue?vue&type=style&index=0&id=996da9f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "996da9f0",
  null
  
)

export default component.exports